<script setup lang="ts">
  import { HLText } from '@platform-ui/highrise'
  defineOptions({ inheritAttrs: false, name: 'CPText' })
</script>

<template>
  <HLText v-bind="$attrs"><slot /></HLText>
</template>
